export const pricingFaq = [
  {
    question: 'Are these prices fixed or estimates?',
    answer: 'Starting prices. Each project gets a fixed quote after a thirty-minute discovery call. We tell you the final number before any work starts.',
  },
  {
    question: 'How do you take payment?',
    answer: 'Fifty percent to start, fifty percent before launch. Bank transfer in EUR. Invoice issued at each milestone.',
  },
  {
    question: 'Do I own the work after payment?',
    answer: 'Yes. Full copyright and source files transfer on final payment. We ask only for the right to include the work in our future portfolio.',
  },
  {
    question: 'What is not included in these prices?',
    answer: 'Stock imagery, custom photography, copywriting, third-party licenses (fonts, CMS subscriptions, hosting). We will tell you in the quote if any of these are needed.',
  },
  {
    question: 'Can I change my mind after signing?',
    answer: 'Yes, with caveats - see our refund policy. Work already completed is not refundable, but the project can be paused or redirected at any point.',
  },
];

export const contactFaq = [
  {
    question: 'How quickly do you reply?',
    answer: 'Within one business day, Cyprus time (GMT+2/3). If we are closed for holidays, our autoresponder will tell you when we are back.',
  },
  {
    question: 'Do you take on clients outside Cyprus?',
    answer: 'Yes. Most of our clients are elsewhere. Everything after the first call can be done remotely.',
  },
  {
    question: 'What should I send with my first message?',
    answer: 'A sentence about what you do and a rough sense of when you want to launch. We will take it from there.',
  },
];
